/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sd_Description_Length_LabelInputs */

const en_sd_description_length_label = /** @type {(inputs: Sd_Description_Length_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scene Description Length`)
};

const fr_sd_description_length_label = /** @type {(inputs: Sd_Description_Length_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description de la scène Durée`)
};

const de_sd_description_length_label = /** @type {(inputs: Sd_Description_Length_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Szenenbeschreibung Länge`)
};

const it_sd_description_length_label = /** @type {(inputs: Sd_Description_Length_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descrizione della scena Lunghezza`)
};

const ru_sd_description_length_label = /** @type {(inputs: Sd_Description_Length_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Описание сцены (длительность)`)
};

const es_sd_description_length_label = /** @type {(inputs: Sd_Description_Length_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descripción de la escena (longitud)`)
};

const zh_cn2_sd_description_length_label = /** @type {(inputs: Sd_Description_Length_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`场景描述长度`)
};

const ja_sd_description_length_label = /** @type {(inputs: Sd_Description_Length_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`シーン描写の長さ`)
};

const hi_sd_description_length_label = /** @type {(inputs: Sd_Description_Length_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`दृश्य विवरण लंबाई`)
};

const pt_pt2_sd_description_length_label = /** @type {(inputs: Sd_Description_Length_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descrição da cena Duração`)
};

/**
* | output |
* | --- |
* | "Scene Description Length" |
*
* @param {Sd_Description_Length_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const sd_description_length_label = /** @type {((inputs?: Sd_Description_Length_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sd_Description_Length_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_sd_description_length_label(inputs)
	if (locale === "de") return de_sd_description_length_label(inputs)
	if (locale === "it") return it_sd_description_length_label(inputs)
	if (locale === "ru") return ru_sd_description_length_label(inputs)
	if (locale === "es") return es_sd_description_length_label(inputs)
	if (locale === "zh-CN") return zh_cn2_sd_description_length_label(inputs)
	if (locale === "ja") return ja_sd_description_length_label(inputs)
	if (locale === "hi") return hi_sd_description_length_label(inputs)
	if (locale === "pt-PT") return pt_pt2_sd_description_length_label(inputs)
	return en_sd_description_length_label(inputs)
});